import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from "react-router-dom";
import * as actions from '../../actions';
import Form from '../Form/Form';
import Popup from '../Form/Popup';
import { trackEvent } from '../../libs';
import '../Preview/Preview.scss';

export class Preview extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = { brochure: null };
  }

  componentWillMount() {
    const { match, carList } = this.props;
    let id = match.params.id
      , car = null;

    if(isNaN(id))
      car = carList.find(i => i.urlPart === id.slice(4));
    else
      car = carList.find(i => i.id === parseInt(id, 10));

    if (carList.length) {
      this.findBrochure(car);
    }
  }

  componentDidMount() {
    setTimeout(() => {
      trackEvent({
        hitType: 'pageview',
        page: location.pathname + location.search + location.hash,
      });
    }, 300);
  }

  componentWillReceiveProps(props) {
    const { match, carList } = props;

    let id = match.params.id
      , car = null;

    if(isNaN(id))
      car = carList.find(i => i.urlPart === id.slice(4));
    else
      car = carList.find(i => i.id === parseInt(id, 10));

    if (carList.length && !this.state.brochure) {
      this.findBrochure(car);
    }
  }

  findBrochure = (car) => {
    const { match, history } = this.props;

    if (car) {
      let { type } = match.params;

      if (!(type === 'accessories' || type === 'custom')) {
        type = null;
      }

      const brochure = car.brochures.find(i => i.type === (!type ? 'brochure' : type));

      if (!brochure) {
        history.push('/');
      } else {
        this.setState({
          brochure: {...brochure, name: `${car.name} ${brochure.title}.pdf`}
        });
      }
    } else {
      history.push('/');
    }
  };

  setBrochure = (name, value, event) => {
    const { actions, brochures } = this.props;

    if (!brochures.some(i => i.name === name)) {
      actions.setBrochures({ name, value });
    }

    trackEvent({
      eventCategory: 'Brochure',
      eventAction: `Go To All Brochures ${event}`,
      eventLabel: name,
    });
  };

  render() {
    const { brochure } = this.state;

    if (!brochure) {
      return null;
    }

    return (
      <div className="preview-brochure">
        <div className="preview-brochure_iframe">
          <iframe
            src={brochure.preview}
            scrolling="No"
            frameBorder="0"
            allowFullScreen
            allowTransparency
            seamless
          />
        </div>

        <div className="container form-container preview-brochure_form-container">
          <div className="row">
            <div className="col-xs-12 form-header">
              <strong>
                Пожалуйста, заполните форму ниже, и&nbsp;мы&nbsp;отправим
                материалы на&nbsp;вашу электронную почту.
              </strong>
            </div>
            <div className="col-xs-12 preview-brochure_link">
              <i className="icon icon-info" />
              Обращаем ваше внимание, что все материалы по&nbsp;данной модели доступны в&nbsp;разделе <Link
              to="/"
              onClick={() => this.setBrochure(brochure.name, brochure.value, 'Link')}
            >
              &laquo;Модельный&nbsp;ряд&raquo;
            </Link>.
            </div>
          </div>
          <Form brochures={[brochure]} />
          <Popup />
        </div>

      </div>
    );
  }
}

Preview.propTypes = {
  actions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  carList: PropTypes.array,
  brochures: PropTypes.array,
  match: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    carList: state.mainReducer.carList,
    brochures: state.mainReducer.brochures,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Preview);



// WEBPACK FOOTER //
// ./src/components/Preview/Preview.js